import React from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { Box } from '@mui/material'
import LinkPlaceConfigFilters from './LinkPlaceConfigFilters'
import { useDispatch } from 'react-redux'
import { masterConfigMenuVSBL } from '../../../../redux/Actions'
const AddLinkPlaceConfig = (props) => {
  const dispatch = useDispatch()
  const { handleAdd, getTableData } = props

  return (
    <Box className='masterConfig_container'>
      <ReportHeader headerName={'Link Place Configuration'} subHeader={"Add Link Place"} mainHeaderName="Master Configuration" openSubMenu={() => dispatch(masterConfigMenuVSBL(true))} fixedTopPosition={true} />
      <LinkPlaceConfigFilters handleBack={handleAdd} getTableData={getTableData} />
    </Box>
  )
}

export default AddLinkPlaceConfig
